"use strict";
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TROUBLESHOOT_ENDPOINT = exports.BRANDING_ENDPOINT = exports.TEST_AVAILABILITY_ENDPOINT = exports.LINK_ENDPOINT = exports.PUBLIC_BOOK_ENDPOINT = void 0;
var PUBLIC_BOOK_ENDPOINT = "meetings-public/v1/book";
exports.PUBLIC_BOOK_ENDPOINT = PUBLIC_BOOK_ENDPOINT;
var LINK_ENDPOINT = "meetings-public/v1/link";
exports.LINK_ENDPOINT = LINK_ENDPOINT;
var TEST_AVAILABILITY_ENDPOINT = 'meetings-public/v1/test-availability';
exports.TEST_AVAILABILITY_ENDPOINT = TEST_AVAILABILITY_ENDPOINT;
var BRANDING_ENDPOINT = 'branding/v1';
exports.BRANDING_ENDPOINT = BRANDING_ENDPOINT;
var TROUBLESHOOT_ENDPOINT = 'meetings-public/v1/troubleshoot';
exports.TROUBLESHOOT_ENDPOINT = TROUBLESHOOT_ENDPOINT;